var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"items-per-page":-1,"hide-default-footer":"","items":_vm.entries,"headers":_vm.aggregateHeaders},on:{"click:row":_vm.onRowClick},scopedSlots:_vm._u([{key:"item.amount",fn:function({item}){return [_c('span',[_vm._v(_vm._s(_vm.formatMoney(item.amount)))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }